export const appid = "dingoari422vvz29uaxyvu" // 钉钉扫码登录 appid（DingLogin.vue 保留未引用，作回滚备用）

// 飞书扫码登录：自建应用 App ID（cli_ 开头）
// 创建应用后还需在 开放平台→安全设置→重定向 URL 中配置：
//   http://localhost:8080/login（本地联调） 与 http://dao.szltech.com/login（生产）
export const feishuAppid = "cli_aa2dddef78ba5bdf"

// export const labour_type = ["按人力计费（单项目开发等）", "项目打包计费（打包项目/模板项目等）", "平台系统搭建服务", "平台运营服务"]
// export const purchase_type = ['按效果计费（推广/销售）', '底层采购（服务器等云服务）', '其他采购（非服务器和非发奖）', '推广服务（ASO/投放）', '视频业务服务', '直播业务服务', '中介服务', '投放服务', '咨询服务', '服务器部署及运维服务', '效果服务']
// export const framework_type = ['框架维护（年度框架/日常运维等）', '人员驻场/外包服务']
// export const design_type = ['框架设计（设计月结等）', '设计打包（打包设计/模板设计）', '营销设计服务']
// export const prize_type = ['奖品发放（代发奖品）', '平台发奖服务']
export const labour_type = ['数字营销渠道业务', '数字营销活动工具业务']
export const purchase_type = ['视频业务服务', '直播业务服务', '中介服务', '投放业务', '文案', '服务器部署及运维服务', '代运营业务', '数字营销系统业务']
export const clue_status_tabs = ['初步接触','方案阶段','权利人阶段','决策阶段','立项阶段','谈判/招投标阶段','报价确认/签约阶段','项目取消','未中标']
export const project_status_list = ['开发', '内部测试', '客户验收中', '已验收']
export const order_status_list = ['正常', '异常']
export const framework_type = []
export const design_type = ['营销设计服务']
export const prize_type = ['平台发奖服务']
export const quotation_type = [].concat(labour_type).concat(purchase_type).concat(framework_type).concat(design_type).concat(prize_type)


// 权限管理
export const DataStatisticsManager = ['戚绮琦']
// 暂时禁止填写订单收入进度名单
export const tempBlock = []
// 填写订单收入进度白名单
export const tempWhite = ['林羽', '詹文珊', '高琳']
// 财务部
export const financialManager = ['钟丽欢', '凌钦颖', '郭铭']
// 管理团队
export const availableInit = ['蔡树彬', '卢良楷', '陈晓伟', '李超悦']
// 客户经理
export const salesManager = ['陈晓乾','束雨璠','林羽','张瑞','詹文珊','周晓杰']
// 项目经理
export const projectManager = ['宁峰', '陈光磊', '邵伟杰', '张娟', '司徒梦蝶', '詹文珊', '钟英杰', '高琳','赵岩','蔡小芸', '彭晓琛', '王少琴']
// 绩效团队
export const performanceManager = ['林羽', '林思博', '陈文瀚']
// 商务团队
export const businessManager = ['吴少盈']
// 部门负责人
export const departmentManager = ['宁峰', '陈晓乾' , '李超悦']
// 运维
export const opsManager = ['彭晓琛']
// 商机模块额外的白名单
export const clueWhite = ['梁文婷','张娟', '司徒梦蝶','高琳']

export const baseURL = "http://research.szltech.com:4001"
export const currDomain = 'http://research.szltech.com:4001'
